import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    params: {
        page: 1,
        per_page: 30,
        q: {
            user_phone: "",
            start_time: "",
            end_time:""
        }
    }
}

const mutations = {
    changeRecordPage(state, val) {
        state.params = val
    }
}

export default {
    state,
    mutations
}